<template>
  <div>
    <!-- NAVBAR -->
    <my-navbar :controller="controller" />

    <!-- HEADER -->
    <div class="header bg-gradient-dark pb-8 pt-5 pt-md-8">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row">
            <!-- CONTENIDO HEADER -->
            <div class="col-lg-12 col-md-12">
              <h1 class="display-3 text-white">Pagos Autofact</h1>
              <p class="text-white mt-0">La búsqueda comprende registros desde enero del presente año hasta la fecha actual.</p>

              <div class="row mt-5">

                <div class="col-lg-3 col-sm-6 col-xs-12 mb-1">
                  <div class="form-group text-white search-input">
                    <label for="input-campaign">Buscar</label>
                    <div class="input-group input-group-alternative">
                      <div class="input-group-prepend" v-b-tooltip.hover title="Ingresa un término de búsqueda">
                        <span class="input-group-text">
                          <i class="fas fa-search"></i>
                        </span>
                      </div>
                      <input @keyup.enter="handleSearch" class="form-control" placeholder="OC, Email, Nombre o Patente " type="text" v-model="searchQry.search" :disabled="loading"/>
                    </div>
                  </div>
                </div>

                <div class="col-lg-3 col-sm-6 col-xs-12 mb-1">
                  <div class="form-group text-white">
                    <label for="input-campaign">Fecha Inicial</label>
                    <input type="date" class="form-control" v-model="searchQry.fecha_i" :min="lastYear" :max="now" :disabled="loading"/>
                  </div>
                </div>

                <div class="col-lg-3 col-sm-6 col-xs-12 mb-1">
                  <div class="form-group text-white">
                    <label for="input-campaign">Fecha Final</label>
                    <input type="date" class="form-control" v-model="searchQry.fecha_f" :min="lastYear" :max="now" :disabled="loading"/>
                  </div>
                </div>

                <div class="col-lg-3 col-sm-6 col-xs-12 mb-1">
                  <div class="form-group">
                    <label for="input-campaign">.</label>
                    <div></div>
                    <div class="btn-group" role="group" aria-label="Basic example">
                      <button class="btn btn-success" @click="handleSearch" :disabled="!validSearch || loading">Buscar</button>
                      <button type="button" class="btn btn-secondary" @click="clean" :disabled="!payments.length > 0">Limpiar</button>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CONTENT -->
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <!-- COMPONENTE PRINCIPAL -->
          <div class="row row-payments">
            <div class="col-lg-12">
              
              <div class="ui-sys-msg jumpIn" v-if="loading" style="position:relative; padding: 0;min-height:200px;">
                <MySpinner :loading="true" />
              </div>

              <template v-else>
                <div class="ui-sys-msg" v-show="!filtered.length  > 0 && noResults">
                  <div class="ui-sys-icon info">
                    <i class="fa fa-info-circle"></i>
                  </div>
                  <p class="ui-sys-text">No se encontraron resultados para tu búsqueda</p>
                </div>

                <div class="card payment-item" v-if="filtered.length  > 0 && !noResults">
                  
                  <div class="card-header payment-title">
                    <div class="row">
                      <div class="col-3">
                          <p class="text-muted">Resultados de la búsqueda</p>
                      </div>
                      <div class="col-3">
                        <div class="form-group m-0 mb-0 d-flex justify-content-end align-center">
                          <span class="small text-muted d-block mr-2 mt-2">Ver por página</span>
                          <select v-model="countOfPageTmp" @change="updatePageCount($event)" class="form-control form-control-sm form-control-alternative"  style="width:200px">
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="form-group m-0 mb-0 d-flex justify-content-end align-center">
                          <span class="small text-muted d-block mr-2 mt-2">Filtrar por</span>
                          <select @change="filterByStatus($event)" class="form-control form-control-sm form-control-alternative"  style="width:200px">
                            <option value="">Todas</option>
                            <option :value="FINISHED">Finalizadas</option>
                            <option :value="UNKNOWN" >Desconocido</option>
                            <option :value="INCOMPLETE">Información Incompleta</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-3" v-if="excel.data.length > 0">
                      
                    <download-excel
                      class="btn btn-secondary btn-sm"
                      :data="getFormatRow(excel.data)"
                      :fields="excel.xlsfields"
                      :name="excel.name"
                      type="xls"
                      v-if="excel.name"
                      :worksheet="excel.worksheet">
                      <img src="@/assets/img/excel-ico.png" width="24px" alt="Exportar"> Exportar
                    </download-excel>
                        </div>
                    </div>
                  </div>

                  <div  v-for="(r, index) in paginated('filtered')" :key="index" class="accordion" id="accordionExample">
                    <div class="card mb-3">
                      <div class="card-header" id="headingOne">
                        <div class="media">
                          <img src="@/assets/img/credit-cards-payment.png" class="car-icon mr-3 hidden-xs"/>
                          <div class="media-body">
                            <h4 class="media-header mt-0 my-1">
                                {{ r.name }} <br/>
                                <small class="text-muted" ><strong>Patente</strong>: <span style="text-transform:uppercase">{{r.reg_number}}</span> / <strong>Email:</strong> {{r.email}}</small>
                            </h4>
                            <button class="btn btn-secondary btn-sm" data-toggle="collapse" :data-target="'#collapseOne'+index" aria-expanded="false" :aria-controls="'collapseOne' + index">
                              <i class="fa fa-credit-card"></i> Ver transacciones
                            </button>
                            <span v-if="hasSomePDF(r.transactions)" class="badge badge-bullet bg-white small"> <i class="fa fa-star text-warning mr-1"></i> Con Informe</span>
                          </div>
                        </div>
                      </div>
                      <div v-if="r.transactions && r.transactions.length > 0" :id="'collapseOne' + index " class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                          <AutofactPaymentsTable :transactions="r.transactions"/>
                      </div>
                    </div>
                  </div>


                  <div class="card-body">
                      <paginate
                        ref="paginator"
                        name="filtered"
                        :list="filtered"
                        :per="countOfPage"
                        tag="tr"
                        class="d-none"
                      ></paginate>
                  </div>

                  <div class="card-footer">
                    <paginate-links
                          :async="true"
                          for="filtered"
                          :show-step-links="true"
                          :limit="5"
                          class="v-paginate v-paginate-justify"
                          :hide-single-page="true"
                      ></paginate-links>
                  </div>

                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import moment from 'moment'
import AutofactPaymentsTable from './Table';
import sysMsgs from '@/helpers/system.message'
import apiPayments from '@/services/finance.services'
const lastMonth = moment(moment().subtract(2, 'months').calendar()).format("YYYY-MM-DD")
const currentYear = moment(moment().startOf('year')).format("YYYY-MM-DD");
const lastYear = moment(currentYear).subtract(1, 'year').calendar()
const now = moment().format("YYYY-MM-DD")

import { ERROR, CREATING, DELIVERED, WITHOUT_INFORMATION, FINISHED, UNKNOWN, INCOMPLETE  } from './constants'
export default {
  name: "AutofactPayments",
  components: { AutofactPaymentsTable },
  data() {
    return {
      loading: false,
      noResults: false,
      controller: {
        title: "Finanzas",
        mainRouter: "/finanzas/pagos"
      },
      searchQry: {
        search: '',
        fecha_i: currentYear,
        fecha_f: now
      },
      payments: [],
      filtered: [],
      transactions: [],
      paginate: ['filtered'],
      excel: {
        data: [],
        name: null,
        worksheet: "Finanzas",
        xlsfields: {
          "Nombre" : "name",
          "Email" : "email",
          "Patente" : "reg_number",
          "Rut" : "rut",
          "Orden_Compra" : "oc",
          "Fecha": "start_date"
        }
      },
      countOfPage: 10,
      countOfPageTmp: 10,
      now,
      lastMonth,
      lastYear,
      currentYear,
      CREATING, DELIVERED, FINISHED, UNKNOWN, INCOMPLETE
    };
  },
  computed: {
    validSearch() {
      return this.searchQry.fecha_i.trim().length > 0 && this.searchQry.fecha_f.trim().length > 0;
    },
    validDatesRange() {
      /*
      * validar si hay menos de 
      * 61 días en el rango de fechas selecionado.
      */
      const { fecha_i, fecha_f} = this.searchQry;
      return moment(fecha_f).diff(moment(fecha_i), 'days') <= 60;
    }
  },
  methods: {
    handleSearch() {
      if (this.validDatesRange) {

        this.searchPayments()

      } else {
        sysMsgs.getDialog("Debe seleccionar un rango no mayor a 60 días.", "warning");
      }
    },
    searchPayments() {
      this.loading = true;
      apiPayments.getAutofactPayments(this.searchQry).then(response => {
        this.payments = response.data.payments;
        this.filtered = response.data.payments;
        
        this.excel.data = response.data.payments;
        let financeDate = new Date();
        this.excel.name = `FinanzasTest_${financeDate.getHours().toString()}${financeDate.getMinutes().toString()}${financeDate.getSeconds().toString()}${financeDate.getMilliseconds().toString()}.xls`;
        
        this.loading = false;
        this.noResults = false;
      }).catch(error => {
        sysMsgs.getResponseMessage(error.response);
        this.payments = [];
        this.noResults = true;
        this.loading = false;
      });
    },
    clean() {
      this.payments = [];
      this.searchQry = {
        search: '',
        fecha_i: '',
        fecha_f: now
      }
    },
    hasSomePDF(transactions) {
      return transactions && transactions.length > 0 ? transactions.filter(item => item.pdf_autofact).length > 0 : false;
    },
    updatePageCount($event) {
      this.countOfPage = parseInt($event.target.value);
      this.countOfPageTmp = this.countOfPage;
    },
    filterByStatus($event) {
      const value = $event.target.value;
      switch (value) {
        case FINISHED:
          this.filtered = this.payments.map(item => ({
            ...item,
            transactions: item.transactions.filter(b => b.status_autofact === DELIVERED && b.pdf_autofact && !b.error_autofact )
          }));
          this.excel.data = this.filtered;
          break;
        
        case UNKNOWN:
          this.filtered = this.payments.map(item => ({
            ...item,
            transactions: item.transactions
            .filter(b => (b.status_autofact === DELIVERED && !b.pdf_autofact && !b.error_autofact) || b.status_autofact === CREATING)
          }));
          this.excel.data = this.filtered;
          break;
        
        case INCOMPLETE:
          this.filtered = this.payments.map(item => ({
            ...item,
            transactions: item.transactions.filter(b => b.status_autofact === DELIVERED && b.error_autofact === WITHOUT_INFORMATION)
          }));
          this.excel.data = this.filtered;
          break;
      
        default:
          this.filtered = [...this.payments];
          this.excel.data = this.filtered;
          break;
      }

      this.filtered = this.filtered.filter(item => item.transactions.length > 0);
      this.excel.data = this.filtered;
      if (this.$refs.paginator) {
        this.$refs.paginator.goToPage(1)
      }

      //this.paginate.filtered.list = this.filtered;
      //this.paginate.filtered.page = 0;


    },
    getFormatRow(data) {
      var retorno = new Object();
      var retorne = [];

      data.map(element => {
        retorno.name = element.name;
        retorno.email = element.email;
        retorno.reg_number = element.reg_number;

        element.transactions.forEach(element2 => {
          retorno.rut = element2.rut;
          retorno.oc = element2.oc;
          retorno.rut = element2.rut;
          retorno.start_date = moment(element2.start_date).format("DD/MM/YYYY, h:mm:ss a")

          retorne.push(retorno);
        });

        retorno = new Object();
      });

      return retorne;
    }
  }
};
</script>